import { Badge } from "@/components/ui/badge";

import { cn, isClosed } from "../lib/util.js";

/* 문을 닫은 곳 표식. closed_stores.json 에 있으면 붙는다(App 이 _closed 를 단다).
   잠시 닫은 곳은 '임시 휴무', 아주 닫은 곳은 항목에 "permanent": true 를 적어 '영업 종료'.
   다시 열면 항목을 stores.json 으로 도로 옮긴다 — 항목을 지우면 id 에 달린 리뷰가
   화면에서 사라진다.

   '신규'(NewMark)와 달리 **말풍선에도 붙는다.** 신규는 훑다가 걸리게 하는 게 일이라
   고른 뒤에는 할 일이 없지만, 이건 고른 뒤에야 비로소 필요한 말이다 — 가려고 핀을
   누른 사람이 헛걸음하지 않게 하는 것. 그래서 좁은 화면에서 접히는 줄(Bubble 의 DETAIL)
   말고 끝까지 남는 이름 옆에 둔다. */
export function ClosedMark({ store, className }) {
  if (!isClosed(store)) return null;

  return (
    <Badge
      className={cn(
        "closed-mark bg-destructive/10 px-1.5 py-0 align-middle text-[10.5px] font-bold text-destructive",
        className,
      )}
    >
      {store.permanent ? "영업 종료" : "임시 휴무"}
    </Badge>
  );
}
